export enum Professions {
  SE_ARBETSTERAPEUT = "Arbetsterapeut",
  SE_AUDIONOM = "Audionom",
  SE_BARNMORSKA = "Barnmorska",
  SE_BIOMEDICINSK_ANALYTIKER = "Biomedicinsk analytiker",
  SE_DIETIST = "Dietist",
  SE_FARMACEUTER = "Farmaceuter",
  SE_FYSIOTERAPEUT = "Fysioterapeut",
  SE_HALSO_OCH_SJUKVARDKURATOR = "Hälso- och sjukvårdskurator",
  SE_INTERNREKRYTERING = "Internrekrytering",
  SE_LAKARE = "Läkare",
  SE_LARARE = "Lärare",
  SE_MEDICINSKA_SEKRETERARE = "Medicinska sekreterare",
  SE_PSYKOLOG = "Psykolog",
  SE_PSYKOTERAPEUT = "Psykoterapeut",
  SE_RONTGENSJUKSKOTERSKA = "Röntgensjuksköterska",
  SE_SOCIONOM = "Socionom",
  SE_SSK = "SSK",
  SE_USK = "USK",

  NO_LEGE = "Lege",
  NO_SYKEPLEIE = "Sykepleie",

  DK_JORDEMODER = "Jordemoder (DK)",
  DK_LAEGER = "Læger (DK)",
  DK_RADIOGRAFER = "Radiografer (DK)",
  DK_SOCIAL_OG_SUNDHEDSASSISTENT = "Social og sundhedsassistent (DK)",
  DK_SYGEPLEJERSKER = "Sygeplejersker (DK)",
  DK_SOCIALPAEDAGOG = "Socialpædagog (DK)",
  DK_HJAELPEPLEJER = "Hjælpeplejer (DK)",
  DK_FAMILJEBEHANDLARE = "Familjebehandlare (DK)",
  DK_SOCIAL_OG_SUNDHEDSHJAELPER = "Social- og sundhedshjælper (DK)",
  DK_PLEJER = "Plejer (DK)",
  DK_SYGEHJAELPER = "Sygehjælper (DK)",
  DK_OMSORGSMEDARBEJDER = "Omsorgsmedarbejder (DK)",
  DK_PSYKIATRIMEDARBEJDER = "Psykiatrimedarbejder (DK)",
  DK_TERAPEUT = "Terapeut (DK)",
  DK_PAEDAGOGISK_ASSISTENT = "Pædagogisk assistent (DK)",
  DK_SOCIALRAADGIVER = "Socialrådgiver (DK)",
  DK_ERGOTERAPEUT = "Ergoterapeut (DK)",
  DK_PAEDAGOGMEDHJAELPER = "Pædagogmedhjælper (DK)",

  FI_LAAKARI = "Lääkäri",
  FI_SAIRAANHOITAJA = "Sairaanhoitaja"
}

export const AreasOfExpertise = {
  SE_AUDIONOM: {
    DEFAULT: "Audionom"
  },
  SE_ARBETSTERAPEUT: {
    DEFAULT: "Arbetsterapeut"
  },
  SE_BARNMORSKA: {
    DEFAULT: "Barnmorska"
  },
  SE_BIOMEDICINSK_ANALYTIKER: {
    DEFAULT: "Biomedicinsk analytiker"
  },
  SE_DIETIST: {
    DEFAULT: "Dietist"
  },
  SE_FARMACEUTER: {
    DEFAULT: "Farmaceuter"
  },
  SE_FYSIOTERAPEUT: {
    DEFAULT: "Fysioterapeut"
  },
  SE_HALSO_OCH_SJUKVARDKURATOR: {
    DEFAULT: "Hälso- och sjukvårdskurator"
  },
  SE_INTERNREKRYTERING: {
    DEFAULT: "Internrekrytering"
  },
  SE_LAKARE: {
    DEFAULT: "Legitimerad läkare"
  },
  SE_PSYKOTERAPEUT: {
    DEFAULT: "Psykoterapeut"
  },
  SE_USK: {
    DEFAULT: "Undersköterska"
  },
  SE_MEDICINSKA_SEKRETERARE: {
    DEFAULT: "Medicinska sekreterare"
  },
  SE_LARARE: {
    DEFAULT: "Lärare"
  },
  SE_PSYKOLOG: {
    DEFAULT: "Psykolog"
  },
  SE_RONTGENSJUKSKOTERSKA: {
    DEFAULT: "Röntgen SSK"
  },
  SE_SSK: {
    DEFAULT: "Legitimerad SSK"
  },
  NO_LEGE: {
    DEFAULT: "Lisensiert lege"
  },
  NO_SYKEPLEIE: {
    DEFAULT: "Sykepleie"
  },
  DK_JORDEMODER: {
    DEFAULT: "Jordemoder (DK)"
  },
  DK_LAEGER: {
    DEFAULT: "Læger (DK)"
  },
  DK_RADIOGRAFER: {
    DEFAULT: "Radiografer (DK)"
  },
  DK_SOCIAL_OG_SUNDHEDSASSISTENT: {
    DEFAULT: "Social og sundhedsassistent (DK)"
  },
  DK_SYGEPLEJERSKER: {
    DEFAULT: "Sygeplejersker (DK)"
  },
  DK_SOCIALPAEDAGOG: {
    DEFAULT: "Socialpædagog (DK)"
  },
  DK_HJAELPEPLEJER: {
    DEFAULT: "Hjælpeplejer (DK)"
  },
  DK_FAMILJEBEHANDLARE: {
    DEFAULT: "Familjebehandlare (DK)"
  },
  DK_SOCIAL_OG_SUNDHEDSHJAELPER: {
    DEFAULT: "Social- og sundhedshjælper (DK)"
  },
  DK_PLEJER: {
    DEFAULT: "Plejer (DK)"
  },
  DK_SYGEHJAELPER: {
    DEFAULT: "Sygehjælper (DK)"
  },
  DK_OMSORGSMEDARBEJDER: {
    DEFAULT: "Omsorgsmedarbejder (DK)"
  },
  DK_PSYKIATRIMEDARBEJDER: {
    DEFAULT: "Psykiatrimedarbejder (DK)"
  },
  DK_TERAPEUT: {
    DEFAULT: "Terapeut (DK)"
  },
  DK_PAEDAGOGISK_ASSISTENT: {
    DEFAULT: "Pædagogisk assistent (DK)"
  },
  DK_SOCIALRAADGIVER: {
    DEFAULT: "Socialrådgiver (DK)"
  },
  DK_ERGOTERAPEUT: {
    DEFAULT: "Ergoterapeut (DK)"
  },
  DK_PAEDAGOGMEDHJAELPER: {
    DEFAULT: "Pædagogmedhjælper (DK)"
  },
  FI_LAAKARI: {
    DEFAULT: "Lääkäri"
  },
  FI_SAIRAANHOITAJA: {
    DEFAULT: "Sairaanhoitaja"
  }
} as const;

// e.g. "Grandskola 1-3 ||| Matematik";
export function createAOESpecialization(aoe: string, specialization: string) {
  return `${aoe}|||${specialization}`;
}

// e.g. "Qualified|||Grandskola 1-3 ||| Matematik";
export function createQualifiedAOESpecialization(aoe: string, specialization: string) {
  return `Qualified|||${aoe}|||${specialization}`;
}

// e.g. "Unqualified|||Grandskola 1-3 ||| Matematik";
export function createUnqualifiedAOESpecialization(aoe: string, specialization: string) {
  return `Unqualified|||${aoe}|||${specialization}`;
}
